import axios from "axios";
import api from "../axios";
import { BASE_URL } from "../../utils/constants";

const getAccountId = () => sessionStorage.getItem("acc_id");

export async function createOrganization(data) {
  const response = await api.post("/tenants/create/", data);
  return response.data;
}

export async function getOrganizationList(change_org = false) {
  const response = await api.get("/tenants/");
  const user = JSON.parse(localStorage.getItem("user"));

  if (
    user?.external_role.name === "TOCA Admin" ||
    user?.account_roles.some((_role) => _role.name === "Super User")
  ) {
    const user_current_org = user?.current_account;
    const existingSessionAccId = sessionStorage.getItem("acc_id");

    let curr_org = null;

    // Tier 0: Respect current tab's sessionStorage (tab-isolated state)
    if (existingSessionAccId && change_org !== true) {
      curr_org = response.data?.find(
        (org) => String(org?.id) === String(existingSessionAccId)
      );
    }

    // Tier 1: Match by preserved fallback_org (user's last choice, survives logout)
    if (!curr_org) {
      try {
        const preserved = JSON.parse(localStorage.getItem("fallback_org"));
        if (preserved?.id) {
          curr_org = response.data?.find((org) => org?.id === preserved.id);
        }
      } catch { /* ignore */ }
    }

    // Tier 2: Match by server-provided user.current_account
    if (!curr_org) {
      curr_org = response.data?.find((org) => org?.id === user_current_org);
    }

    // Tier 3: First org in list (existing behavior)
    if (!curr_org) {
      curr_org = response.data?.[0];
    }

    // Only update storage when session is empty or actively switching
    if (!existingSessionAccId || change_org === true) {
      localStorage.setItem("fallback_org", JSON.stringify(curr_org));
      sessionStorage.setItem("acc_id", curr_org?.id);
      sessionStorage.setItem("acc_name", curr_org?.name);
      sessionStorage.setItem("schema_name", curr_org?.schema_name);
    }
    await getLocationList(change_org);
  }
  return response.data;
}

export async function getLocationList(change_org = false, accountId = null) {
  const tenantId = accountId || getAccountId();
  const response = await api.get(
    `/accounts/${tenantId}/locations/?status=active`
  );
  const locs = response?.data?.locations || [];

  // Safely get user ID and parse user's current location from localStorage
  const sessionLoc = sessionStorage.getItem("current_loc");
  const user = JSON.parse(localStorage.getItem("user"));
  const user_current_loc = user?.current_location;

  let current_loc = null;

  // Tier 1: Match by preserved fallback_location (user's last choice, survives logout)
  try {
    const preserved = JSON.parse(localStorage.getItem("fallback_location"));
    if (preserved?.id) {
      current_loc = locs.find((loc) => loc.id === Number(preserved.id));
    }
  } catch { /* ignore */ }

  // Tier 2: Match by server-provided user.current_location
  if (!current_loc && user_current_loc) {
    current_loc = locs.find((loc) => loc.id === Number(user_current_loc));
  }

  // Tier 3: First location (existing behavior)
  if (!current_loc) {
    current_loc = locs[0] || {};
  }

  // Only update session storage if fetching for current account
  if (!accountId || String(accountId) === String(getAccountId())) {
    if (!sessionLoc || change_org === true) {
      localStorage.setItem("fallback_location", JSON.stringify(current_loc));
      sessionStorage.setItem("current_loc", JSON.stringify(current_loc));
    }
  }

  return response?.data;
}

export async function switchAccountLocation(data) {
  // const tenantId = getAccountId()
  const user = JSON.parse(localStorage.getItem("user"));
  const accessToken = localStorage.getItem("authToken");

  // const response = await api.post(`/users/${tenantId}/switching/`, data);
  const response = await axios.post(
    `${BASE_URL}/users/${user?.account?.id}/switching/`,
    data,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return response.data;
}

export async function updateOrganization(data) {
  const tenantId = getAccountId();
  const response = await api.patch(`/tenants/${tenantId}/edit/`, data);
  return response.data;
}

export async function getOrganizationDetails() {
  const tenantId = getAccountId();
  const response = await api.get(`/tenants/${tenantId}/detail/`);
  return response.data;
}
